import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit, OnDestroy, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import PreVisitRecordTicketForPersonService from '../../services/pre-visit-record-ticket-for-person.service';
import RestService from '../../services/core-rest.service';
import Toast from '../../services/toast.service';
import SymptomCheckService from '../../services/symptom-check.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import AngularStateHelperService from '../../services/angular-state-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { MatSidenavModule, MatDrawer } from '@angular/material/sidenav';
import { Subscription } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';

@Component({
	standalone: true,
	selector: 'drawer-pre-visit-record-for-person-notes',
	templateUrl: './drawer-pre-visit-record-for-person-notes.component.html',
	imports: [ CommonModule, MatSidenavModule, TranslatePipe, FormsModule, LoaderOverlayComponent ]
})
export class DrawerPreVisitRecordForPersonNotesComponent implements OnInit, OnDestroy {
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private preVisitRecordTicketForPersonService: PreVisitRecordTicketForPersonService = inject(PreVisitRecordTicketForPersonService);
	private restService: RestService = inject(RestService);
	private toast: Toast = inject(Toast);
	private symptomCheckService: SymptomCheckService = inject(SymptomCheckService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularStateHelperService: AngularStateHelperService = inject(AngularStateHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private router: Router = inject(Router);
	
	@ViewChild('preVisitFinishDrawer') preVisitFinishDrawer: MatDrawer;

	vm: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	navigationSubscription: Subscription = undefined;
	
	constructor() {
		this.vm = this;
		this.vm.initialized = false;
	}
	
	ngOnInit() {
		this.vm.uid = 'dn-' + Date.now();
		this.vm.showEndInterviewSection = false;
		this.vm.preVisitType = 'NEW_HEALTH_PROBLEM'
		this.vm.triageLevel = undefined;
		this.vm.selectedServiceIds = {};
		this.vm.otherDescriptionConf = {};
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(
				this, "togglePreVisitFinishDrawer", (event, data) => {
					this.vm.config = data.config;
					this.vm.interview = data.interview;
					this.vm.isOpen = this.vm.interview.open;
					if (this.vm.isOpen) {
						this.angularStateHelperService.setGlobalProperty('noDocScroll', true);
						this.vm.otherDescriptionConf = this.angularFilterHelperService.filter(this.vm.config, {fieldName: 'OTHER_DESCRIPTION'})[0];
						this.vm.additionalRequestOptions = this.angularFilterHelperService.filter(this.vm.config, {fhirSection: 'SERVICE_REQUEST_ORDER_DETAILS'});
						this.vm.locationSelection = this.angularFilterHelperService.filter(this.vm.config, {fhirSection: 'SERVICE_REQUEST_LOCATION_CODE'});
						this.vm.infermedicaId = this.angularFilterHelperService.filter(this.vm.config, {fieldName: 'INFERMEDICA_INTERVIEW_ID'});
						this.swapScroller(true);
						this.preVisitFinishDrawer.open();
					} else {
						this.close();
					}
				})
		);
		this.navigationSubscription = this.router.events.subscribe(
			(event: any) => {
				if (event instanceof NavigationEnd) {
					if (this.vm.isOpen) {
						this.close();
					}
				}
			}
		);
		
		this.vm.close = this.close;
		this.vm.submit = this.submit;
		this.vm.initialized = true;
	}
	
	ngOnDestroy() {
		if (this.navigationSubscription) {
			this.navigationSubscription.unsubscribe();
		}
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}
	
	submit(mainForm: any) {
		this.vm.submitted = true;
		var hasLocation = false;
		for (var i = 0; i < this.vm.locationSelection.length; i++) {
			var location = this.vm.locationSelection[i];
			if (this.vm.selectedServiceIds[location.id]) {
				hasLocation = true;
				break;
			}
		}
		this.vm.hasLocationSelected = hasLocation;
		
		if (mainForm.invalid || this.vm.processing || !hasLocation) {
			return;
		}
		
		if (this.vm.isSaving) {
			return;
		}
		
		var deferred: any = this.angularHelperService.getDeferredPromise();
		
		var ticketServiceRequestOptions: Array<any> = [];
		for (var selectedServiceId in this.vm.selectedServiceIds) {
			if (!this.vm.selectedServiceIds[selectedServiceId]) {
				continue;
			}
			for (var index in this.vm.config) {
				var serviceSelectionElement: any = this.vm.config[index];
				if (serviceSelectionElement.id == selectedServiceId && this.vm.selectedServiceIds[selectedServiceId]) {
					serviceSelectionElement.content = this.vm.selectedServiceIds[selectedServiceId];
					ticketServiceRequestOptions.push(serviceSelectionElement)
				}
			}
		}
		if (this.vm.otherDescriptionConf.content) {
			ticketServiceRequestOptions.push(this.vm.otherDescriptionConf);
		}
		if (this.vm.infermedicaId.length > 0) {
			var infermedicaInterviewIdOption: any = this.vm.infermedicaId[0]
			infermedicaInterviewIdOption.content = this.vm.interview.localId;
			ticketServiceRequestOptions.push(infermedicaInterviewIdOption)
		}
		
		var submitData: any = {
			"type": this.vm.preVisitType,
			"priority": this.vm.triageLevel,
			"selectedServiceRequestDetails": ticketServiceRequestOptions
		}
		submitData = this.preVisitRecordTicketForPersonService.addRecordTicketForPersonData(submitData);
		
		this.vm.isSaving = true;
		this.restService.savePreVisitNewHealthProblem(submitData)
			.then((response) => {
				this.vm.isSaving = false;
				deferred.resolve();
				this.angularHelperService.createTimer(() => {
					this.toast.showAsync(
						this.angularFilterHelperService.translate('PreVisit.Record_For_Person_Notes_Drawer.Toast_Message_Success'),
						undefined,
						10000
					);
				}, 500);
				this.angularHelperService.createTimer(() => {
					// clear interview data
					this.symptomCheckService.updateInterview({});
				});
				this.vm.close();
				this.angularRoutingHelperService.setPath('/pre-visit');
			})
			.catch((error) => {
				this.vm.isSaving = false;
				console.log(error);
			});
		
		return deferred.promise;
	}
	
	resetInputs() {
		this.vm.submitted = false;
		this.vm.showEndInterviewSection = false;
		this.vm.preVisitType = 'NEW_HEALTH_PROBLEM'
		this.vm.triageLevel = undefined;
		this.vm.selectedServiceIds = {};
		this.vm.otherDescriptionConf = {};
		this.vm.isSaving = false;
	}
	
	close() {
		this.resetInputs();
		this.vm.interview.open = false;
		this.angularStateHelperService.setGlobalProperty('noDocScroll', false);
		this.swapScroller(false);
		this.preVisitFinishDrawer.close();
	}

	swapScroller(value) {
		if (value) {
			document.body.classList.add("u-no-scroll");
		} else {
			document.body.classList.remove("u-no-scroll");
		}
	}
	
}